/**
 * Class strings shared by the vision and values sections. Constants rather than utilities in
 * `app.css` so moving a section between pages cannot shift a pixel.
 */

/**
 * The header of every section: 20px on a phone, 24px from 768px up, over a flat 28px line box.
 *
 * The two pixel values are the `text-xl` and `text-2xl` steps spelt out. Written as a
 * `max-md:` / `md:` pair rather than a base class and its own variant, because the mirror
 * typography utilities of `app.css` carry `!important` -- a base class there beats its own `md:`
 * step, and the header would never grow.
 */
export const VISION_SECTION_TITLE =
    'text-navy max-md:text-[20px] md:text-[24px] leading-[28px] font-medium';
